// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_card__tJi59 {
  border: 0;
  margin-bottom: 30px;
  margin-top: 30px;
  border-radius: 6px;
  color: rgba(var(--cardBackground), 0.87);
  background: #e9f5f3 !important;
  width: 100%;
  box-shadow: 0 1px 4px 0 rgba(var(--blackColorRGB), 0.14) !important;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  font-size: 0.875rem;
}

.card_inputAdornment__CeRS4 {
  margin-right: 18px;
}

.card_inputAdornmentIcon__pz8Rg {
  color: var(--grayColor);
}

.card_number__8Wd0X input::-webkit-outer-spin-button,
.card_number__8Wd0X input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Card/css/card.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;EAC9B,WAAW;EACX,mEAAmE;EACnE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX","sourcesContent":[".card {\n  border: 0;\n  margin-bottom: 30px;\n  margin-top: 30px;\n  border-radius: 6px;\n  color: rgba(var(--cardBackground), 0.87);\n  background: #e9f5f3 !important;\n  width: 100%;\n  box-shadow: 0 1px 4px 0 rgba(var(--blackColorRGB), 0.14) !important;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  font-size: 0.875rem;\n}\n\n.inputAdornment {\n  margin-right: 18px;\n}\n\n.inputAdornmentIcon {\n  color: var(--grayColor);\n}\n\n.number input::-webkit-outer-spin-button,\n.number input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `card_card__tJi59`,
	"inputAdornment": `card_inputAdornment__CeRS4`,
	"inputAdornmentIcon": `card_inputAdornmentIcon__pz8Rg`,
	"number": `card_number__8Wd0X`
};
export default ___CSS_LOADER_EXPORT___;
